import React from 'react';
import { FileDrop } from 'react-file-drop';
import { makeStyles } from '@material-ui/core';
import SVG from 'react-inlinesvg';
import { toAbsoluteUrl } from '../../_metronic/_helpers';
import { ICONS } from 'src/utils/icon-urls.utils';

const useStyles = makeStyles((theme) => ({
	expandClickeableArea: {
		display: 'flex',
    	width: '100%',
    	justifyContent: 'center'
	},
	target: {
		display: 'flex',
		alignitems: 'center',
		justifycontent: 'center',
		flexdirection: 'column',
		cursor: 'pointer',
		border: 'dashed 4px #dfdfdf',
		padding: '20px',
		//borderradius: '16px',
		//padding: '55px',
		color: '#808080',
		backgroundcolor: '#808080',
		//fontsize: '20px',
		transition: '0.3s ease-in',
		width: '100%',
		//height: '50%',
		height: '100%',
		justifyContent: 'center',
		alignItems: 'center',
		alignContent: 'center',
	},
	target2: {
		flexdirection: 'column',
		cursor: 'pointer',
		border: 'dashed 4px #ffffff',
		padding: '20px',
		color: '#808080',
		backgroundcolor: '#808080',
		transition: '0.3s ease-in',
		width: '100%',
	},
	hidden: {
		display: 'none',
	},
	text: {
		textalign: 'center',
		margin: '0 auto',
		width: '80%',
		display: 'flex',
		padding: '8px',
		alignitems: 'center',
	},
	x: {
		marginleft: '8px',
		fontsize: '18px',
		fontweight: 'bold',
		cursor: 'pointer',
	},
	root: {
		width: '100%',
		margin: 0,
		height: '100%',
	},
}));

const Upload = (props) => {
	const { 
		selectFile, 
		setSelectFile, 
		onFileInputChange, 
		fileInputRef, 
		onTargetClick ,
		onDrop
	} = props;

	const classes = useStyles();

	return (
		<div className={classes.target}>
			<div className={classes.expandClickeableArea}>
				<input
					type="file"
					onChange={onFileInputChange}
					ref={fileInputRef}
					hidden
				/>

				<FileDrop
					onDrop={(files, event) => onDrop(files)}
					onTargetClick={onTargetClick}
					//targetClassName={classes.target2}
					className={`${classes.filedrop} ${classes.expandClickeableArea}`}
					draggingOverFrameClassName={classes.filedropDrag}
				>
					<div className="p-15">
						<div className="text-center svg-icon svg-icon-8x">
							<SVG
								src={toAbsoluteUrl(
									'/media/svg/icons/Files/Cloud-upload.svg'
								)}
							/>
						</div>
						<p> Clic o Arrastra el Archivo</p>
					</div>
				</FileDrop>
			</div>

			<div className="d-flex align-items-center">
				<div className={classes.text}>
					<p>
						{selectFile !== null ? (
							<div className="transparent-container">
								{selectFile?.name}
								<span
									className={classes.x}
									onClick={() => {
										fileInputRef.current.value = null;
										setSelectFile(null);
									}}
								>
									<SVG
										src={ICONS.DELETED_FILE}
									/>
								</span>
							</div>
						) : (
							'  '
						)}
					</p>
				</div>
			</div>
		</div>
	);
};

export default Upload;
